import reactDom from 'react-dom'
import '../../style/main-image.css'
import MainSearch from './MainSearch'
// import { connect } from 'react-redux'
// import { refreshTheme } from '../../actions'
// import { useEffect } from 'react'

const MainImage = (props) => {
    // const { refreshTheme } = props;
    // const gradiant = window.getComputedStyle(document.body).getPropertyValue('--main-image-gradiant')
    // useEffect(() => {
    //     refreshTheme()
    // }, [refreshTheme, gradiant])
    // console.log(gradiant)
    return reactDom.createPortal(
    <div className="main-image-con">
        <div className="ui container">
            <div className="main-title">
                <h1 className="main-title-text">Home of the Experts</h1>
            </div>
            <MainSearch />
        </div>
    </div>, document.getElementById('main-image')
    )
}

// export default connect(mapStateToProps)(MainImage)

export default MainImage;